<template>
  <div class="report_daily mr-bt-table">
    <Table
      header="รายการข้อมูล Referrer"
      v-bind:columns="[
        'รหัสพนักงาน',
        'ชื่อ - สกุล',
        'รหัสสาขา',
        'วันที่สร้าง',
        'สร้างโดย',
        'ACTION',
      ]"
    >
      <template slot="search-box">
        <div class="col-sm-12">
          <section class="panel panel-default">
            <div class="panel-heading">
              <h4>ค้นหาข้อมูล Referrer</h4>
            </div>

            <div class="panel-body h5">
              <div class="col-lg-12 no-padd-m">
                <div class="form-group">
                  <label class="col-lg-2 col-xs-3 control-label m-t-xs">รหัสพนักงาน:</label>
                  <div class="col-lg-4 col-xs-5">
                    <input type="text" class="form-control input-sm" v-model="search.staffId" />
                  </div>
                  <div class="col-lg-4 col-xs-3 no-padd-m">
                    <button
                      type="button"
                      class="btn btn-default"
                      style="margin-left:20px;"
                      @click="searchReferrer()"
                    >
                      <i class="glyphicon glyphicon-search"></i> ค้นหาข้อมูล
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </template>

      <template slot="main">
        <tr v-for="result in results" :key="result.staffId">
          <td>{{ result.staffId }}</td>
          <td>{{ result.firstName }} {{ result.lastName }}</td>
          <td>{{ result.referrerBranchId }}</td>
          <td>{{ formatDockDateTimeTh(result.createdDate) }}</td>
          <td>{{ result.createdBy }}</td>
          <td>
            <div class="btn-group m-b-sm">
              <button
                v-bind:class="[
                  { 'btn btn-primary button-width-150': result.isActive },
                  { 'btn btn-default button-width-150': !result.isActive },
                ]"
                @click="changeActive(result.staffId, result.isActive)"
              >
                <span v-if="result.isActive"> Active</span>
                <span v-else> InActive</span>
              </button>
              <button class="btn btn-dark button-width-150" @click="editRefer(result)">
                <i class="fa fa-pencil"></i> แก้ไข
              </button>
            </div>
          </td>
        </tr>

        <tr v-if="!results.length">
          <td colspan="11">
            <div style="margin: 4em 0px;">ไม่พบข้อมูล</div>
          </td>
        </tr>
      </template>

      <template slot="paginate">
        <PaginateTable
          v-show="results.length != 0"
          v-model="pagination"
          :page="pagination.page"
          :per_page="pagination.per_page"
          :last_page="pageNum"
          :total="total"
        ></PaginateTable>
      </template>
    </Table>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-form-refer"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form-refer"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-form-refer">
              แก้ไขข้อมูลพนักงาน
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </h5>
          </div>
          <div class="modal-body">
            <form class="form-inline">
              <div class="form-group pull-in clearfix">
                <div class="col-sm-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">รหัสพนักงาน :</span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="detail.staffId"
                      readonly
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      maxlength="5"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group pull-in clearfix">
                <div class="col-sm-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">ชื่อ :</span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="detail.firstName"
                      :class="{ 'bd-red': errors.has('firstName') }"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group pull-in clearfix">
                <div class="col-sm-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">นามสกุล :</span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="detail.lastName"
                      :class="{ 'bd-red': errors.has('lastName') }"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group pull-in clearfix">
                <div class="col-sm-12">
                  <div class="input-group">
                    <span class="input-group-addon nobd-nobg">รหัสสาขา :</span>
                    <input
                      type="text"
                      class="form-control"
                      v-model="detail.referrerBranchId"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      :class="{ 'bd-red': errors.has('referrerBranchId') }"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="saveChangeRefer()">
              Save changes
            </button>
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { createHelpers } from 'vuex-map-fields'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { Validator } from 'vee-validate'

import Table from '@/components/Table/Index'
import DatePickerTH from '@/components/Form/DatePickerTH'
import downloadExcel from 'vue-json-excel'
import PaginateTable from '@/components/Table/PaginateTable'
import API from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const { mapFields: mapReferrerFields } = createHelpers({
  getterType: 'getReferrerFields',
  mutationType: 'updateReferrerFields',
})

export default {
  name: 'ManageReferrerList',
  data: () => ({
    hello: '2',
    pagination: {
      page: 1,
      per_page: 20,
    },
    search: {
      staffId: null,
    },
    pageNum: 0,
    total: 0,
    results: [],
    detail: {
      staffId: null,
      firstName: null,
      lastName: null,
      referrerBranchId: null,
    },
    rules: {
      firstName: 'required',
      lastName: 'required',
      referrerBranchId: 'required|numeric',
    },
    errors: null,
  }),
  watch: {
    pagination() {
      this.init()
    },
    isReferrerUpdated() {
      this.init()
    },
  },
  computed: {
    ...mapGetters(['formatDockDateTimeTh']),
    ...mapReferrerFields({
      isReferrerUpdated: 'isUpdate',
    }),
  },
  components: {
    Table,
    DatePickerTH,
    PaginateTable,
    downloadExcel,
  },
  methods: {
    ...mapActions(['api_update_referrer', 'api_update_status']),
    searchReferrer() {
      this.pagination.page = 1
      this.init()
    },
    init() {
      var search = {
        page: this.pagination.page,
        per_page: this.pagination.per_page,
      }

      if (this.search.policy_status != '0') {
        search.staffId = this.search.staffId
      }

      this.$http
        .get(API.BACK_OFFICE.GET_REFERRER_LIST, {
          params: search,
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        })
        .then(
          response => {
            this.results = response.body.result.referrers
            this.pageNum = response.body.result.pageNum
            this.total = response.body.result.total
          },
          response => {
            if (
              response.body.statusCode === 400 &&
              response.body.message === 'Invalid data from db'
            ) {
              this.results = []
            }
          },
        )
    },
    editRefer(data) {
      this.detail = {
        staffId: data.staffId,
        firstName: data.firstName,
        lastName: data.lastName,
        referrerBranchId: data.referrerBranchId,
      }
      $('#modal-form-refer').modal('show')
    },
    saveChangeRefer() {
      this.validator
        .validateAll({
          firstName: this.detail.firstName,
          lastName: this.detail.lastName,
          referrerBranchId: this.detail.referrerBranchId,
        })
        .then(result => {
          if (result) {
            this.api_update_referrer(this.detail)
          }
        })
    },
    changeActive(staffId, isActive) {
      let data = {
        staffId: staffId,
        isActive: !isActive,
      }
      this.api_update_status(data)
    },
    setRule() {
      this.validator = new Validator(this.rules)
      this.$set(this, 'errors', this.validator.errors)
    },
  },
  created() {
    this.setRule()
  },
}
</script>

<style lang="scss"></style>
